import React, {Component} from 'react';
// Cart Popup
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import {Close as CloseIcon, AccessTime} from '@material-ui/icons';
// import CloseIcon from '@material-ui/icons/Close';
import Countdown from 'react-countdown-now';

import {connect} from 'react-redux';
import {removeItemFromCart, removeAllItemsFromCart, addTimeToCart} from '../ReduxActions/CartActions'

/**
 * Props:
 * @prop {*} --hideDuration - Defaults to 6000
 * @prop {*} cartDate
 * @prop {*} handleCartTimerClose
 * @prop {*} vertical - Defaults to 'bottom'
 * @prop {*} horizontal - Defaults to 'left'
 * @prop {*} openTimer
 */


// Example handle close to use from parent, don't need event
/*
  handleClose = (event) => {
    this.setState({ open: false });
  };
*/
class SuccessPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openTimer: true,
      openAddMoreTime: false // Toast th
    }

    this.x = null;
  }

  componentDidMount() {


    this.checkTime();

    this.x = setInterval(this.checkTime, 3*60000);

  }

  checkTime = () => {
    let theDate = new Date(this.props.cartDate);
    theDate.setMinutes(theDate.getMinutes() + 15);

    let now = new Date();
    var diffDates = now.getTime() - theDate.getTime();

    if (diffDates >= 180000) {
      this.setState({
        openTimer: false,
        openAddMoreTime: false
      })
      this.handleCompleteClose(); // Delete all cart items, they are too old
      
    }
    else if (diffDates >= 0 && diffDates < 180000) {
      this.setState({
        openTimer: false,
        openAddMoreTime: true
      })
    }
    else {
      this.setState({
        openTimer: true,
        openAddMoreTime: false
      })
    }
  }

  handleCartTimerClose = (e) => {
    e.preventDefault();

    this.setState({
      openTimer: false
    })
  }

  onComplete = () => {

    this.setState({
      openTimer: false,
      openAddMoreTime: true
    })
  }

  /**
   * Add 15 minutes to the users cart time
   */
  handleAddTime = (e) => {
    // Add more time to the cart
    this.props.dispatchAddCartTime(this.props.Auth.sessionId);
  }

  /**
   * Remove all items from users cart using sessionId
   */
  handleCompleteClose = () => {
    this.props.dispatchRemoveAllItemsFromCart(this.props.Auth.sessionId); // remove all items from cart

    // Remove items from the cart and server
  }

  render() {
    let theDate = new Date(this.props.cartDate);
    theDate.setMinutes(theDate.getMinutes() + 15);

    let now = new Date();
    var diffDates = now.getTime() - theDate.getTime();

    console.log("The difference: ", diffDates);
    console.log("The date: ", theDate);

    return (
        <div>
          {/* Time Left in the Cart Popup */}
          <Snackbar
            anchorOrigin={{
              vertical: this.props.vertical ? this.props.vertical : 'bottom',
              horizontal: this.props.horizontal ? this.props.horizontal : 'right',
            }}
            open={this.state.openTimer}
            
            // autoHideDuration={this.props.hideDuration ? this.props.hideDuration : 6000}
            // onClose={this.props.handleSuccessClose}
            >
              <SnackbarContent
                style={{backgroundColor: '#313131'}}
                message={<span id="client-snackbar" style={{display: 'flex', alignItems: 'center'}}><AccessTime style={{fontSize: 20}} />Items will be stored in your cart for: <Countdown date={theDate} onComplete={this.onComplete} /></span>}
                action={<IconButton key="close" color="inherit" onClick={this.handleCartTimerClose}><CloseIcon style={{fontSize: 20}} /></IconButton>}
              />
          </Snackbar>

          {/* Option to add more time to the cart */}
          <Snackbar
            anchorOrigin={{
              vertical: this.props.vertical ? this.props.vertical : 'bottom',
              horizontal: this.props.horizontal ? this.props.horizontal : 'right',
            }}
            open={this.state.openAddMoreTime}
            
            // autoHideDuration={this.props.hideDuration ? this.props.hideDuration : 6000}
            // onClose={this.props.handleSuccessClose}
            >
              <SnackbarContent
                style={{backgroundColor: '#313131'}}
                message={<span id="client-snackbar" style={{display: 'flex', alignItems: 'center'}}><AccessTime style={{fontSize: 20}} />Cart session has expired, would you like to add more time? </span>}
                action={[
                  <Button key="yes" color="secondary" size="small" onClick={this.handleAddTime}>YES</Button>,
                  <IconButton key="close" color="inherit" onClick={this.handleCompleteClose}><CloseIcon style={{fontSize: 20}} /></IconButton>
                ]}
              />
          </Snackbar>
        </div>


    )
  }
}

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth,
    Cart: state.Cart
  }
}

const mapDispatchToProps = {
  dispatchRemoveFromCart: (product) => removeItemFromCart(product),
  dispatchRemoveAllItemsFromCart: (sessionId) => removeAllItemsFromCart(sessionId),
  dispatchAddCartTime: (sessionId) => addTimeToCart(sessionId)
}


export default connect(mapStateToProps, mapDispatchToProps)(SuccessPopup);